module dg.loading {

    export class LoadingController {
       
        $onInit = () => {
            
        }

        $onChanges = (c) => {
        }
    }

    angular.module('dg.loading')
        .component('loading', {
            bindings: {
            },
            controller: LoadingController,
            template: '<div class="loader-spinner"></div>'
            //templateUrl: '/digmo/src/loading/loading.html'
        });
}
